import React, { useState } from 'react';
import { Add, ExpandMore } from '@mui/icons-material';
import { Button, Menu, MenuItem } from '@uplift/ui-v2';

import { CreateSupervisionMeetingModal } from './CreateSupervisionMeetingModal.component';


export const ActivitiesActionMenu: React.VFC<{ superviseeId: string }> = (props) => {
  const [ meetingModalOpen, setMeetingModalOpen ] = useState(false);

  return (
    <>
      <Menu
        renderAnchor={({ onClick }) => (
          <Button variant="contained" color="secondary" startIcon={<Add />} endIcon={<ExpandMore />} onClick={onClick}>
            Add Activity
          </Button>
        )}
      >
        <MenuItem onClick={() => setMeetingModalOpen(true)}>
          Supervision Meeting
        </MenuItem>
      </Menu>
      <CreateSupervisionMeetingModal
        open={meetingModalOpen}
        onClose={() => setMeetingModalOpen(false)}
        providerId={props.superviseeId}
      />
    </>
  );
};
